export default __webpack_public_path__ + "static/2-5--c5082dacee488fa6b439bb79ffe5a4fe.png";